export const getAllTeams = (state, allTeam) => {
  return {
    ...state,
    teams: [...allTeam],
  };
};

export const updateTeam = (state, team) => {
  const teamsCopy = [...state.teams];

  teamsCopy[
    teamsCopy.findIndex((tTeam) => {
      return tTeam.id === team.id;
    })
  ] = {
    ...team,
  };

  return {
    ...state,
    teams: teamsCopy,
  };
};

export const createTeam = (state, team) => {
  var newTeams = Array.from(new Set([team, ...state.teams]));

  return {
    ...state,
    teams: newTeams,
  };
};

export const deleteTeam = (state, team) => {
  var newTeams = state.teams.filter((myTeam) => myTeam.id !== team.id);

  return {
    ...state,
    teams: newTeams,
  };
};

export const clearAllTeams = () => {
  return {
    teams: [],
  };
};

export const saveTName = (state, name) => {
  return {
    ...state,
    searchedName: name,
  };
};

export const saveSort = (state, sort) => {
  return {
    ...state,
    sortingOrder: sort,
  };
};

export const clearSearch = (state) => {
  return {
    ...state,
    searchedName: "",
  };
};
